import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import withRouter from '../util/WithRouter';
import LoginAPI from '../api/LoginAPI';
import ApiUiController from '../controller/ApiUiController';
import config from '../config/config';

class Logout extends React.Component {

  componentDidMount() {
    if (reactLocalStorage.get(Const.LoggedIn) !== Const.STrue) {this.props.navigate('/');}
    else { LoginAPI.logout(this.onSuccess, this.onSuccess, this.onSuccess); }
  }
  
  onSuccess = () => { 
    reactLocalStorage.clear();
    window.location.href = config.auth + 'logout';
  }
  
  render() { return <ApiUiController inApiCall={true} /> }
}
export default withRouter(Logout);